var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen flex flex-col",attrs:{"id":"app"}},[_c('HeaderView'),_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('router-view',{staticClass:"flex-1"})],1),_c('FooterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }